module.exports = __webpack_public_path__ + "img/workshops.95490ded.svg";